import { createFileRoute } from "@tanstack/react-router";

import { SiteDetailPage } from "../features/sites/SiteDetailPage";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/",
)({
  component: SiteDetailRoute,
});

function SiteDetailRoute() {
  const { accountSlug, tenantSlug, siteSlug } = Route.useParams();
  return (
    <SiteDetailPage
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      siteSlug={siteSlug}
    />
  );
}
